// extracted by mini-css-extract-plugin
export default {"systemDetailsOverviewPopover":"SystemDetailsOverviewPopover_systemDetailsOverviewPopover__kBQcy","systemDetailsOverview":"SystemDetailsOverviewPopover_systemDetailsOverview__kkqK6"};